module.exports = __webpack_public_path__ + "img/narozniki-zderzaka-przedniego.23814972.jpg";